import Header from "../components/Header";
import Footer from "../components/Footer";

function Talks() {

    const conferenceExperience = [
        {
            conf: 'Australian Statistics Conference',
            title: 'Efficient Direct Sampling Schema for Gaussian Hierarchical Models with Proportional Scale Priors',
            year: '2025',
            location: 'Perth, WA, Australia'
        },
        {
            conf: 'Australian Data Science Network',
            title: 'Emulating human expertise in rezoning: a case study of the Australian Statistical Geography Standard',
            year: '2024',
            location: 'Perth, WA, Australia'
        },
        {
            conf: 'Locate24 Conference',
            title: 'A Novel Algorithm for Creating Australian Statistical Geographies',
            year: '2024',
            location: 'Sydney, NSW, Australia'
        },
        {
            conf: 'HEAL Conference - Healthy Environment and Lives',
            title: 'Service accessibility impact mapping for disaster resilience in Queensland, Australia',
            year: '2023',
            location: 'Online'
        },
        {
            conf: 'Australian Data Science Network',
            title: 'A Novel Algorithm for Creating Australian Statistical Geographies',
            year: '2023',
            location: 'Adelaide, SA, Australia'
        }
    ];

    // Component for an individual job entry
    const ExperienceItem = ({ conf, title, year, location, index}) => {
        if(index%2===0){
        return (
            <div className="animate-slide-in-right mb-6 p-4 border-accent border-2 rounded-lg shadow-sm">
                <div className="flex justify-between items-center mb-1">
                    <h3 className="text-xl font-semibold text-text">{conf}</h3>
                </div>
                <p className="text-base text-text">{title}</p>
                <p className="text-lg font-medium text-accent mb-2">{year}</p>
                <p className="text-text text-base mb-2">{location}</p>
            </div>
        );
        }else{
        return (
            <div className="animate-slide-in-left mb-6 p-4 border-accent border-2 rounded-lg shadow-sm">
                <div className="flex justify-between items-center mb-1">
                    <h3 className="text-xl font-semibold text-text">{conf}</h3>
                </div>
                <p className="text-base text-text">{title}</p>
                <p className="text-lg font-medium text-accent mb-2">{year}</p>
                <p className="text-text text-base mb-2">{location}</p>
            </div>
        );
        }
    };




    return (
        <div className="flex flex-col min-h-screen">
            <Header />
            <main className="bg-topography flex-grow flex flex-col items-center justify-center gap-y-4">
                {/* Second Publication Card */}
                <div className="w-full flex flex-col justify-center items-center">
                    <div className="w-screen h-24" />
                    <div className="flex flex-col gap-10">
                        <div className="p-4 lg:pr-8">
                            {conferenceExperience.map((conf, index) => (
                                <ExperienceItem key={index} {...conf} index={index} />
                            ))}
                        </div>
                    </div>
                    <div className="w-screen h-12" />
                </div>
            </main>
            <Footer />
        </div>
    );
}
export default Talks;